<script type="text/ecmascript-6">
    export default {
        props: {
            fieldname: null,
            type: null,
            primarykey: null,
            object: null,
            url: null,
            attr: null,
        },

        mounted: function() {
            this.$nextTick(function () {
                $('#'+this.id).editable({
                    showbuttons: true,
                    url: this.url,
                    onblur: 'submit',
                    placement: 'bottom',
                    success: function (response, newValue) {
                        if (response.success)
                        {
                            if($('#'+this.id).hasClass('empty-field')){
                                $('#'+this.id).removeClass('empty-field')
                            }

                            toastr.success('New value saved successfully');

                        } else {
                            toastr.error('An error has occurred');
                        }
                    }.bind(this)
                });
            });
        },

        computed: {
            value: function () {
                if (this.object && this.object[this.fieldname] != '0000-00-00')
                {
                    return this.object[this.fieldname];
                }

                return null;
            },
            id: function () {
                return this.fieldname + '_' + this.primarykey;
            }
        }
    }
</script>

<template>
    <div class="scoop-editable">
        <template v-if="type == 'select'">
            <a :id="id"
               :class="{ 'empty-field': !value }"
               :data-name="fieldname"
               :data-type="type"
               :data-pk="primarykey"
               data-emptytext="empty"
               :data-source="attr.ajaxUrl"
               :data-value="value"
               data-rows="3"
            ></a>
        </template>
        <template v-else>
            <a :id="id"
               :class="{ 'empty-field': !value }"
               :data-name="fieldname"
               :data-type="type"
               :data-pk="primarykey"
               data-rows="3"
               data-emptytext="empty"
               data-title=""
            >{{ value }}</a>
        </template>

        <div id="popover-content" class="hide">
            <form class="form-inline" role="form">
                <div class="form-group">
                    <input />
                </div>
            </form>
        </div>
    </div>
</template>

<style>
    .editable-pre-wrapped{
        white-space: normal;
    }
</style>
